import { render, staticRenderFns } from "./SettingTheme.vue?vue&type=template&id=28653fa6&"
import script from "./SettingTheme.vue?vue&type=script&lang=ts&"
export * from "./SettingTheme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports